import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/ArtsDepartment.css';

const artsDepts = [
  { name: 'Marathi', established: 2013, intake: 120, link: '/departments/arts/marathi' },
  { name: 'Hindi', established: 2013, intake: 120, link: '/departments/arts/hindi' },
  { name: 'Economics', established: 2013, intake: 120, link: '/departments/arts/economics' },
  { name: 'English', established: 2013, intake: 120, link: '/departments/arts/english' },
  { name: 'History', established: 2013, intake: 120, link: '/departments/arts/history' },
  { name: 'Political Science', established: 2013, intake: 120, link: '/departments/arts/political-science' },
  { name: 'Psychology', established: 2013, intake: 120, link: '/departments/arts/psychology' },
  { name: 'Sociology', established: 2013, intake: 120, link: '/departments/arts/sociology' },
  { name: 'Philosophy', established: 2013, intake: 120, link: '/departments/arts/philosophy' },
  { name: 'Geography', established: 2013, intake: 120, link: '/departments/arts/geography' },
];

const ArtsDepartment = () => {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    window.scrollTo(0,0);
    setTimeout(() => setFade(true), 100);
  }, []);

  return (
    <>
      <Navbar />
      <section className='section-wrapper-no-text-align'>
      <div className={`arts-container ${fade ? 'fade-in' : ''}`}>
        <section className="arts-header">
          <h4>Shri Mulikadevi Mahavidyalaya, Nighoj</h4>
          <h2>Arts Faculty & Departments</h2>
          <p>
            Our Arts faculty features a range of disciplines including languages, social sciences, and humanities — fostering critical thinking, cultural awareness, and social understanding.
          </p>
        </section>

        <section className="arts-cards">
          {artsDepts.map((dept, i) => (
            <div key={i} className="arts-card animate-card">
              <h3>{dept.name}</h3>
              <p><strong>Established:</strong> {dept.established}</p>
              <p><strong>Intake:</strong> {dept.intake} per year</p>
              <a href={dept.link} className="learn-btn">Learn More</a>
            </div>
          ))}
        </section>
      </div>
      </section>
      <Footer />
    </>
  );
};

export default ArtsDepartment;
